import {
  LoadTypeName,
  LoadUnitType,
  LoadSpecifications,
  LoadDimensions
} from '@/services/models/marketplace-service-model'

/** Helper function to build the weight string */
function getWeight(value: number): string {
  return value ? `${value}t` : ''
}

function setLabelAndUnit({ label, value }: { label: string; value: number }): string {
  if (!value) return ''
  return `${label} ${value}cm`
}

/** Helper function to build the quantity & unit string */
function getQuantity(value: number, unit: LoadUnitType): string {
  const quantityStr = value ? `${value} ` : ''
  const unitStr = unit ? LoadTypeName[unit] : 'items'
  return quantityStr + unitStr
}

function getPalletInformation({
  loadQuantity,
  loadUnitType
}: {
  loadQuantity: number
  loadUnitType: LoadUnitType
}): string {
  if (loadQuantity || loadUnitType) {
    return getQuantity(loadQuantity, loadUnitType)
  }
}

export function formatDimensions(dimensions: LoadDimensions, delimiter = ' x '): string {
  return Object.values(dimensions)
    .filter(Boolean)
    .join(delimiter)
}

/** Generates string that contains all the specifications of given order or placeholder */
export function generateSpecifications({
  loadWeight,
  loadLength,
  loadHeight,
  loadWidth,
  loadQuantity,
  loadUnitType
}): LoadSpecifications {
  if (
    !loadWeight &&
    !loadLength &&
    !loadHeight &&
    !loadWidth &&
    !loadQuantity &&
    !loadUnitType
  )
    return null

  return {
    weight: getWeight(loadWeight),
    dimensions: formatDimensions({
      length: setLabelAndUnit({ label: 'L', value: loadLength }),
      height: setLabelAndUnit({ label: 'H', value: loadHeight }),
      width: setLabelAndUnit({ label: 'W', value: loadWidth })
    }),
    palletInformation: getPalletInformation({ loadQuantity, loadUnitType })
  }
}
